export const BASE_URL = "https://api.daralfikr.edunixsystem.com"
// https://edunix-api.beetronix.com
// https://api.alawal.edunixsystem.com

// api.daralfikr.edunixsystem.com/files/logo.png
// https://api.mirror.edunixsystem.com/
export const STORAGE_NAME = "auth"
export const STORAGE_ACTIVE_USER = "active-user"